<div class="grid mb-3">
    <app-platform-health-database-indicators [database]="database"></app-platform-health-database-indicators>
</div>

<!-- el bloque ya llegó 'ok': si buildChart() no encontró datos para esta serie concreta, no se deja
     el hueco en silencio (se leería como "todo tranquilo"), se dice qué falta. Si el bloque entero
     fuera 'unavailable' no haría falta: ya lo explica el aviso general de la pestaña. -->
<div *ngIf="database?.status?.status === 'ok'">
    <app-platform-health-chart [title]="databaseChartTitle()" [chart]="databaseChart" [options]="chartOptions"
        [emptyMessage]="databaseChartEmptyMessage()"
        helpText="Media por intervalo de CPU, Data IO, escritura de log, workers y sesiones de la base de este inquilino. Los picos puntuales no se ven aquí: para eso está el indicador de CPU máxima. Comparte eje de tiempo con las gráficas de API a propósito: es la comparación que dice si el cuello está en la aplicación o en la base."></app-platform-health-chart>

    <!-- una base en pool mide su CPU relativa al pool: al 20% con el pool al 100% es otro
         diagnóstico completamente distinto. Solo se pinta cuando el inquilino tiene pool. -->
    <app-platform-health-chart *ngIf="database?.poolName" [title]="poolChartTitle()"
        [chart]="poolChart" [options]="chartOptions"
        [emptyMessage]="poolEmptyMessage()"
        helpText="Las mismas métricas del pool que esta base comparte con otras, también en media por intervalo. Una base al 20% con el pool al 100% es un diagnóstico distinto: el límite lo está poniendo el pool, no la base."></app-platform-health-chart>
</div>

<div *ngIf="users?.status?.status === 'ok'">
    <h3 class="mt-4 mb-2">
        Usuarios de la base
        <app-platform-health-help-icon
            text="Usuarios que existen en la base de este inquilino (sys.database_principals) y cuántas sesiones tiene abierta cada uno ahora mismo. No incluye si el login está habilitado o deshabilitado: ese dato vive en la base master, que la aplicación no consulta."></app-platform-health-help-icon>
        <small class="text-color-secondary font-normal">
            (foto de las {{ users!.capturedAtUtc | date:'HH:mm:ss' }})
        </small>
    </h3>
    <p-table [value]="users!.users" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Usuario</th>
                <th>Tipo</th>
                <th class="text-right">Sesiones</th>
                <th class="text-right">Activas</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-u>
            <tr>
                <td>{{ u.name }}</td>
                <td>{{ u.type }}</td>
                <td class="text-right">{{ u.sessions }}</td>
                <td class="text-right">{{ u.activeSessions }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="sessions?.status?.status === 'ok'">
    <h3 class="mt-4 mb-2">
        Sesiones por usuario
        <app-platform-health-help-icon
            text="Conexiones abiertas en la base en este instante, agrupadas por login y por aplicación. Es lo que distingue la carga de la propia aplicación de la de un proceso externo, como un ETL o una herramienta de informes."></app-platform-health-help-icon>
        <small class="text-color-secondary font-normal">
            (foto de las {{ sessions!.capturedAtUtc | date:'HH:mm:ss' }})
        </small>
    </h3>
    <p-table [value]="sessions!.groups" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Login</th>
                <th>Aplicación</th>
                <th class="text-right">Sesiones</th>
                <th class="text-right">Activas</th>
                <th class="text-right">CPU (ms)</th>
                <th class="text-right">Lecturas</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-g>
            <tr>
                <td>{{ g.loginName }}</td>
                <td>{{ g.programName }}</td>
                <td class="text-right">{{ g.sessions }}</td>
                <td class="text-right">{{ g.activeSessions }}</td>
                <td class="text-right">{{ g.cpuMs | number:'1.0-0' }}</td>
                <td class="text-right">{{ g.logicalReads | number:'1.0-0' }}</td>
            </tr>
        </ng-template>
    </p-table>

    <h3 class="mt-4 mb-2">
        Consultas en ejecución
        <app-platform-health-help-icon
            text="Peticiones que la base está ejecutando ahora mismo, de más a menos tiempo transcurrido. La columna de bloqueo señala qué sesión está esperando a otra. Cortar una sesión requiere el permiso PLATFORM_HEALTH.KILL_SESSION y se confirma antes de actuar; no se puede cortar la de la propia aplicación, la del servicio de fondo ni la de VoIP, aunque se tenga el permiso."></app-platform-health-help-icon>
    </h3>
    <p-table [value]="sessions!.running" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Sesión</th>
                <th>Login</th>
                <th>Aplicación</th>
                <th class="text-right">Transcurrido (ms)</th>
                <th>Estado</th>
                <th>Espera</th>
                <th class="text-right">Bloqueada por</th>
                <th>Consulta</th>
                <th *ngIf="canKillSession"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-r>
            <tr>
                <td>{{ r.sessionId }}</td>
                <td>{{ r.loginName }}</td>
                <td>{{ r.programName }}</td>
                <td class="text-right">{{ r.elapsedMs | number:'1.0-0' }}</td>
                <td>{{ r.status }}</td>
                <td>{{ r.waitType }}</td>
                <td class="text-right">{{ r.blockingSessionId || '' }}</td>
                <td class="text-xs" [pTooltip]="r.queryText" tooltipPosition="left">
                    {{ r.queryText | slice:0:80 }}
                </td>
                <td *ngIf="canKillSession">
                    <button pButton type="button" icon="pi pi-times-circle" pTooltip="Cortar sesión"
                        class="p-button-text p-button-danger p-button-sm" (click)="onKillClick(r)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
